import React from 'react'
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs'
import ExportReport from './partials/ExportReportScreen';

const breadcrumbs = [{ name: 'گزارش‌ها', link: null }];

export default function Reports() {
    return (
        <div>

            <ABreadcrumbs links={breadcrumbs} />

            <ExportReport />
        </div>
    )
}
